import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../molecules/BrandModal.css";

export const ApproveModal = ({ toggle, setToggle, onApprove, account }) => {
  const [submitting, setSubmitting] = useState(false);

  const close = () => setToggle(false);

  const handleApprove = async () => {
    setSubmitting(true);
    try {
      await onApprove();
      close();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Approve Account</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">
          Are you sure you want to approve{" "}
          <strong>{account?.name || "this request"}</strong>? This will notify
          the finance team for final approval.
        </p>
        <div className="brand-modal__actions">
          <button
            type="button"
            className="brand-modal__btn brand-modal__btn--primary"
            onClick={handleApprove}
            disabled={submitting}
          >
            <FontAwesomeIcon icon={faCheckCircle} />{" "}
            {submitting ? "Approving…" : "Confirm"}
          </button>
          <button
            type="button"
            className="brand-modal__btn brand-modal__btn--cancel"
            onClick={close}
            disabled={submitting}
          >
            <FontAwesomeIcon icon={faTimes} /> Close
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};
